import { useNavigate, useParams } from '@exam-management/router';
import { Button, Flex, Text, ArrowBackOutlinedIcon, ErrorOutlineIcon } from '@shared/components';

export default function ResultsErrorState() {
  const { courseId } = useParams('/exam-courses/:courseId/qsets/generator/results');
  const navigate = useNavigate();

  const backToQSetsGeneratorList = () => {
    return navigate('/exam-courses/:courseId/qsets', {
      params: { courseId },
    });
  };

  return (
    <Flex
      sx={(theme) => ({
        minHeight: '244px',
        py: theme.spacing(25),
        gap: theme.spacing(4),
        flexDirection: 'column',
        alignItems: 'center',
      })}
    >
      <ErrorOutlineIcon
        sx={(theme) => ({
          fontSize: 100,
          color: theme.palette.error.main,
        })}
      />
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(2),
          textAlign: 'center',
        })}
      >
        <Text variant='h3'>ไม่พบชุดข้อสอบที่ผ่านเกณฑ์</Text>
        ชุดข้อสอบมีค่าความซ้ำเกินเกณฑ์ที่กำหนด คุณสามารถปรับเกณฑ์หรือสร้างชุดข้อสอบใหม่
      </Flex>
      <Button
        size='large'
        variant='outlined'
        color='secondary'
        onClick={backToQSetsGeneratorList}
        startIcon={<ArrowBackOutlinedIcon />}
      >
        Back
      </Button>
    </Flex>
  );
}
